var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82008 28C8.20675 28 7.69475 27.7947 7.28408 27.384C6.87253 26.9724 6.66675 26.46 6.66675 25.8467V6.15333C6.66675 5.54 6.87253 5.028 7.28408 4.61733C7.69475 4.20578 8.20675 4 8.82008 4H23.1801C23.7934 4 24.3054 4.20578 24.7161 4.61733C25.1276 5.028 25.3334 5.54 25.3334 6.15333V25.8467C25.3334 26.46 25.1281 26.972 24.7174 27.3827C24.3059 27.7942 23.7934 28 23.1801 28H8.82008ZM16.0001 13.4867L18.6667 11.8973L21.3334 13.4867V5.33333H16.0001V13.4867Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/icon_folder.ac42cd96435515ef34c970aeeeac9b00.svg";
export { ForwardRef as ReactComponent };